import React from "react";
import { Modal } from "react-bootstrap";
import HealthClassSteps from "./HealthClassSteps";
import './HealthClassCalcButton.scss'

export default function HealthClassAnalysis(props) {
  function handleClick() {
    props.fields.setModalHealthCalcIsOpen(false);
  }

  return (
    <React.Fragment>
      <HealthClassAnalysis.ModalHeroImageHeader
        onButtonClick={() => handleClick()}
        healthClassRatingLabel={props.currentHealthClass}
      />
      <div className="modal-scroll p-0">
        <HealthClassSteps
          setModalHealthCalcIsOpen={props.fields.setModalHealthCalcIsOpen}
          onHealthClassChange={props.onHealthClassChange}
        />
      </div>
    </React.Fragment>
  )
}

HealthClassAnalysis.ModalHeroImageHeader = function (props) {

  const healthClass = props.healthClassRatingLabel || 'Good Health';

  return (
    <Modal.Header closeButton>
      <div className="healthRatingImageHeader">
        <div className="healthRatingHeroImage"></div>
        <div className="headerModalDiv">
          <p>My Health Rating</p>
          <p id="faceTotal">
            {healthClass}
          </p>
        </div>
      </div>
    </Modal.Header>
  )
}
